module.exports = __webpack_public_path__ + "static/media/close-mob.b3427e8b.svg";